import { Asterisk } from "lucide-react";

const WORDS = Array.from({ length: 6 }, (_, i) => `mp-${i}`);

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w) => (
      <span key={w} className="flex items-center">
        <span className="px-6 sm:px-10 font-display uppercase text-4xl sm:text-6xl lg:text-7xl tracking-[-0.03em] whitespace-nowrap">Mister Pollo</span>
        <Asterisk className="w-8 h-8 sm:w-12 sm:h-12 shrink-0" strokeWidth={3} />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="marquee-section" aria-label="Mister Pollo" className="relative py-6 sm:py-8 bg-[#FF5500] text-[#0D0D0F] overflow-hidden -rotate-[1.5deg] scale-[1.03] my-10">
    <div className="flex w-max animate-[marquee_60s_linear_infinite]">
      <Row />
      <Row />
    </div>
  </section>
);
